import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios.get(`${API}/pages/${slug}`)
      .then(r => setPage(r.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (error || !page) return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <Navigation />
      <div className="max-w-3xl mx-auto px-6 py-16 text-center">
        <h1 className="text-3xl font-heading font-bold text-primary mb-4">Page Not Found</h1>
        <p className="text-muted-foreground mb-6">The page you're looking for doesn't exist or hasn't been published.</p>
        <Button onClick={() => navigate('/')}>Go Home</Button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-slate-50 to-slate-100">
      <Navigation />
      <div className="flex-1 max-w-3xl mx-auto px-6 md:px-12 py-12 w-full">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mb-6"><ArrowLeft className="w-4 h-4 mr-2" /> Back</Button>
        <article data-testid="cms-page-content">
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4" data-testid="cms-page-title">{page.title}</h1>
          <div className="text-xs text-muted-foreground mb-8">
            Last updated: {new Date(page.updated_at).toLocaleDateString('en-IN')}
          </div>
          <div
            className="prose prose-slate max-w-none [&>h2]:text-2xl [&>h2]:font-heading [&>h2]:font-bold [&>h2]:mt-8 [&>h2]:mb-4 [&>h3]:text-xl [&>h3]:font-heading [&>h3]:font-bold [&>h3]:mt-6 [&>h3]:mb-3 [&>p]:text-muted-foreground [&>p]:leading-relaxed [&>p]:mb-4 [&>ul]:list-disc [&>ul]:pl-6 [&>ul]:mb-4 [&>ol]:list-decimal [&>ol]:pl-6 [&>ol]:mb-4"
            dangerouslySetInnerHTML={{ __html: page.content }}
          />
        </article>
      </div>
      <Footer />
    </div>
  );
};

export default ContentPage;
